import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePageTitle as usePageTitleContext } from '../contexts/PageTitleContext';

// Page title mappings
const PAGE_TITLES: Record<string, { title: string; description?: string }> = {
  '/': { 
    title: 'Overview', 
    description: 'Monitor your secured assets, folder monitoring, and system status.' 
  },
  '/assets': { 
    title: 'Assets', 
    description: 'Files or folders you have access to. All encrypted with Governate.' 
  },
  '/folders': { 
    title: 'Folders', 
    description: 'Manage your monitored folders and auto-encryption settings.' 
  },

  '/notifications': { 
    title: 'Notifications', 
    description: 'Stay updated on file access, security alerts, and system notifications.' 
  },
  '/support': { 
    title: 'Support', 
    description: '' 
  },
  '/settings': { 
    title: 'Settings', 
    description: 'Configure your account settings and preferences.' 
  },
  '/profile': { 
    title: 'Profile', 
    description: 'Manage your user profile and account information.' 
  },
  '/contacts': { 
    title: 'Contacts', 
    description: 'Manage your contacts and groups.' 
  },
  '/clients': { 
    title: 'Clients', 
    description: 'Manage clients and their settings in the system.' 
  },
  '/users': { 
    title: 'Users', 
    description: 'Manage your users and their permissions.' 
  },
  '/devices': { 
    title: 'Devices', 
    description: 'View and manage registered devices across your organization.' 
  },
  '/invitations': { 
    title: 'Invitations', 
    description: 'Invite users to your organisation or manage your reader invites.' 
  },
  '/administration/usages': { 
    title: 'Usage', 
    description: 'Reader licenses, full licenses, and usage (devices, folders) per user for your organisation.' 
  },
};

export const usePageTitle = (customTitle?: string, customDescription?: string) => {
  const location = useLocation();
  const { setPageTitle } = usePageTitleContext();

  useEffect(() => {
    if (customTitle) {
      // Use custom title if provided
      setPageTitle(customTitle, customDescription);
    } else {
      // Use default title based on route
      const pageInfo = PAGE_TITLES[location.pathname];
      if (pageInfo) {
        setPageTitle(pageInfo.title, pageInfo.description);
      } else {
        // Fallback for unknown routes
        setPageTitle('Cloud Admin');
      }
    }
  }, [location.pathname, setPageTitle, customTitle, customDescription]);
};
